import { Leaf, WheatOff, Nut, Milk, Flame, Egg, Sprout } from "lucide-react";
import { cn } from "@/lib/utils";

const TAG_MAP = {
  veg:    { label: "VEG",    icon: Leaf,     cls: "bg-emerald-100 text-emerald-800" },
  vegan:  { label: "VEGAN",  icon: Sprout,   cls: "bg-green-100 text-green-900" },
  gf:     { label: "GF",     icon: WheatOff, cls: "bg-amber-100 text-amber-900" },
  nuts:   { label: "NUTS",   icon: Nut,      cls: "bg-orange-100 text-orange-900" },
  dairy:  { label: "DAIRY",  icon: Milk,     cls: "bg-blue-100 text-blue-900" },
  spicy:  { label: "SPICY",  icon: Flame,    cls: "bg-red-100 text-red-900" },
  egg:    { label: "EGG",    icon: Egg,      cls: "bg-yellow-100 text-yellow-900" },
};

export const AllergenBadge = ({ tag, className = "" }) => {
  const t = TAG_MAP[tag];
  if (!t) return null;
  const Icon = t.icon;
  return (
    <span
      data-testid={`tag-${tag}`}
      className={cn(
        "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider",
        t.cls, className
      )}
    >
      <Icon size={11} strokeWidth={2.5} />
      {t.label}
    </span>
  );
};

export default AllergenBadge;
